import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Toast } from '@services/components/ToastService/toast.types';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  host: {
    '[attr.data-type]': 'toast.type',
    '[attr.data-variant]': 'toast.variant ?? "outline"',
    '[class.is-dismissible]': 'toast.dismissible',
  },
})
export class ToastComponent {
  @Input({ required: true }) toast!: Toast;

  @Output() dismissed = new EventEmitter<string | number>();
  @Output() acted = new EventEmitter<string | number>();

  public get icon(): string {
    const icons: Record<string, string> = {
      success: '✓',
      error: '✕',
      warning: '⚠',
      info: 'ℹ',
      neutral: '●',
    };
    return icons[this.toast.type] ?? '';
  }

  public onDismiss(): void {
    this.dismissed.emit(this.toast.id);
  }

  public onAction(): void {
    this.acted.emit(this.toast.id);
  }
}
